import { Component, Input } from '@angular/core';

@Component({
  selector: 'mtm-task-icon',
  templateUrl: './mtm-task-icon.component.html',
  styleUrl: './mtm-task-icon.component.scss',
  standalone: true,
})
export class MtmTaskIconComponent {
  @Input() active: boolean = false;
}
